<template>
  <div
    class="flex"
    :class="alignment"
  >
    <div>
      <slot name="image" />
    </div>

    <div
      class="ml-3"
      :class="labelClass"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsMediaObjects'
})

const props = defineProps({
  align: {
    type: String,
    default: 'center',
    validator: value => ['top', 'center', 'bottom'].includes(value)
  },

  labelClass: {
    type: String,
    default: ''
  }
})

const alignment = computed(() => {
  const align = {
    top: 'items-start',
    center: 'items-center',
    bottom: 'items-end'
  }

  return align[props.align]
})

</script>
